'use strict';

var $    = require('jquery');
var Core = require('../core/core.js');

/**
 * Creates an inspector with checkbox
 *
 * @class
 */

class InspectorCheckbox extends Core {

    _defaults() {
        return {
            target: '.js-editor',
            fields: {
                'title': '',
                'checked': false,
                'tooltip': '',
                'read_only': false
            }
        };
    }

    constructor(options) {
        super(options);

        this._options.fields["randomNumber"] = Math.round(Math.random(0, Infinity)*100000000);

        this.template = `
            <div class="editor__inspector__item editor__inspector__item--single">
                <div class="editor__inspector__item__label" title="<%- tooltip %>"><%- title %></div>
                <div class="editor__inspector__item__checkbox_outer">
                    <div class="editor__inspector__item__checkbox_container">
                        <input class="editor__inspector__item__checkbox js-editor__inspector__item__checkbox" id="inspectorCheckbox<%= randomNumber %>" type="checkbox" <% if(checked){ %><%- "checked" %><% } %> <% if(read_only){ %>disabled="disabled"<% } %>>
                        <label for="inspectorCheckbox<%= randomNumber %>"></label>
                    </div>
                </div>
            </div>
        `;

        super.render();


        /**
        * Checkbox
        *
        * @fires InspectorCheckbox#_checkboxchanged
        */

        $('.js-editor__inspector__item__checkbox', this.$el).on('change', this._checkboxchanged);

        if(options.fields['read_only']) {
            $('.editor__inspector__item__checkbox_container', this.$el).addClass('editor__inspector__item__checkbox_container--read__only');
        }
    }

    /**
     * @event InspectorCheckbox#Cioui:Inspector:boolean
     * @property {String}Cioui:Inspector:boolean
     * @returns {Boolean} value - true if checkbox is checked, false if not
     */

    _checkboxchanged(e){
        $(e.currentTarget).trigger('Cioui:Inspector:boolean', ($(e.currentTarget).is(':checked') ? true : false));
    }

    /**
    * setBoolean
    *
    * @param {Boolean} checked - set a boolean that checks the checkbox
    */

    setBoolean(checked){
        if(checked === "")
            $('.js-editor__inspector__item__checkbox', this.$el).prop('indeterminate', true);
        else
            $('.js-editor__inspector__item__checkbox', this.$el).prop('checked', checked);
    }
}
module.exports = InspectorCheckbox;
